export const getPercent = (cur, total) => {
  return Math.trunc(cur/total * 100);
};
